import React from 'react';
import { block } from 'bem-cn';

import './pion-content-photo.scss';
import { withStopPropagation } from '../../../utils';
import PhotoPionImage from '../PhotoPionImage';
import ExpandButton from '../PionExpandButton';
import { PionType } from '../../../type';

const b = block('pion-content-photo');

type PionPhotoContentPropsType = {
  pion?: PionType;
  lang: string;
  onImageClick: (id: string | number) => void;
  renderAddPhotoButton?: () => React.ReactNode;
};

type PionPhotoContentStateType = {
  isExpanded: boolean;
  contentHeight: null | string;
};

class PionPhotoContent extends React.PureComponent<
  PionPhotoContentPropsType,
  PionPhotoContentStateType
> {
  state = {
    isExpanded: false,
    contentHeight: null,
  };

  contentRef = React.createRef<HTMLUListElement>();

  toggleContent = () => {
    if (!this.contentRef) {
      return;
    }

    const blockHeight = `${this.contentRef.current?.offsetHeight}px`;

    this.setState((prevState) => {
      const isExpanded = !prevState.isExpanded;
      const contentHeight = isExpanded ? blockHeight : null;
      return { isExpanded, contentHeight };
    });
  };

  static defaultProps: { onImageClick: () => void };

  render() {
    const { pion, lang, onImageClick, renderAddPhotoButton } = this.props;
    const { isExpanded, contentHeight } = this.state;
    const itemsInRow = 5;

    return (
      <>
        <div className={b()}>
          <ul
            className='pion-photo-list'
            ref={this.contentRef}
            data-testid='photo-list'
          >
            {pion
              ?.get('photos')
              .slice(0, itemsInRow)
              .map((photo: any /* TODO: photo Type */) => (
                <li
                  data-testid='photo-pion-item'
                  key={photo.get('id')}
                  className='pion-photo-list__item'
                  onClick={() => onImageClick(photo.get('id'))}
                >
                  <PhotoPionImage
                    url={photo.get('smallUrl')}
                    caption={photo.get('caption')}
                  />
                </li>
              ))}
            {renderAddPhotoButton && pion?.get('photos').size <= itemsInRow && (
              <li className='pion-photo-list__item'>
                {renderAddPhotoButton()}
              </li>
            )}
          </ul>
          <div
            data-testid='hidden-content'
            className={b('hidden-content')}
            style={{ height: contentHeight || '' }}
          >
            <ul
              className='pion-photo-list'
              ref={this.contentRef}
              data-testid='photo-list'
            >
              {pion
                ?.get('photos')
                .slice(itemsInRow)
                .map((photo: any /* TODO: photo Type */) => (
                  <li
                    key={photo.get('id')}
                    className='pion-photo-list__item'
                    onClick={() => onImageClick(photo.get('id'))}
                  >
                    <PhotoPionImage
                      url={photo.get('smallUrl')}
                      caption={photo.get('caption')}
                    />
                  </li>
                ))}
              {renderAddPhotoButton &&
                pion?.get('photos').size > itemsInRow && (
                  <li className='pion-photo-list__item'>
                    {renderAddPhotoButton()}
                  </li>
                )}
            </ul>
          </div>
        </div>

        {pion?.get('photos').size > itemsInRow && (
          <ExpandButton
            expanded={isExpanded}
            onClick={withStopPropagation(this.toggleContent)}
            type={pion?.get('type')}
            lang={lang}
          />
        )}
      </>
    );
  }
}

export default PionPhotoContent;
